import React from 'react'
import Recorridos from './../../../utils/import.recor360'

import close from './../../../UI/icons/Galerias/Close.svg'

interface Props{
    recorrido360Opened: boolean,
    aptoRecor360Name: string,
    handleBubble360: any
}

interface State{
    link: string
}

interface Recorridos {
    Recorridos?: any
}

class Recorrido360 extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {
            link: ""
        } 
    }

    componentDidUpdate(prevProps: any){
        if(this.props.recorrido360Opened !== prevProps.recorrido360Opened || this.props.aptoRecor360Name !== prevProps.aptoRecor360Name){
            this.handleMountLink()
        }
    }

    handleMountLink = () => {
        const links: Recorridos = {Recorridos}
        this.setState({link: links.Recorridos[this.props.aptoRecor360Name]})
    }

    render(){
        return(
            <div className={this.props.recorrido360Opened ? "recorrido-360 fade-in":"recorrido-360 fade-out"}>
                <div className="close-gallery" onClick={() => {this.props.handleBubble360("")}}>
                        <img src={close}></img>
                
                </div>
                <iframe src={this.state.link} className={this.props.recorrido360Opened ? "recor-360-frame fade-in":"recor-360-frame fade-out"}></iframe>
            </div>
        )
    }
}

export default Recorrido360